import 'regenerator-runtime/runtime';
import { call, put, takeEvery } from 'redux-saga/effects';
import { AnyAction } from 'redux';
import { GlobalActions, GlobalPut, HTTP_METHOD } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { CheckoutActions } from '../checkout.actions';

export const URL_AUSSCHLUSS = '/privatschutz/api/gesundheitausschluss';

export function* watchGesundheitAusschlussListRequest() {
  yield takeEvery(
    GlobalActions.AUTHENTICATION_SUCCESSFUL,
    safeSaga(getGesundheitAusschlussListSaga, App.SHOP_CHECKOUT),
  );
  yield takeEvery(
    CheckoutActions.AUSSCHLUSS_REQUEST_SUCCESSFUL,
    safeSaga(successCallback, App.SHOP_CHECKOUT),
  );
}

export function* getGesundheitAusschlussListSaga() {
  const globalPut = GlobalPut.getInstance();
  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().doRequest({
      appId: App.SHOP_CHECKOUT,
      method: HTTP_METHOD.GET,
      body: '',
      url: URL_AUSSCHLUSS,
      successEvent: CheckoutActions.AUSSCHLUSS_REQUEST_SUCCESSFUL,
      errorEvent: CheckoutActions.AUSSCHLUSS_REQUEST_FAILED,
    }),
  );
}

export function* successCallback(successAction: AnyAction) {
  const ausschlussResponse: string[] = successAction.payload;
  yield put(new CheckoutActions().ausschlussListReceived(ausschlussResponse));
}
